import { createActions } from 'reduxsauce';

const { Types: types, Creators: actions } = createActions({
    // add type
    requestSubmitType: ['id', 'data'],
    submitTypeSucceeded: ['data'],
    submitTypeFailed: ['errors'],

    // clear state
    clearTypeCreateState: null,
});

export default {
    // add type
    [types.REQUEST_SUBMIT_TYPE]: (state) => ({
        ...state,
        create: {
            ...state.create,
            submitting: true,
            errors: null,
        },
    }),
    [types.SUBMIT_TYPE_SUCCEEDED]: (state, { data }) => ({
        ...state,
        create: {
            ...state.create,
            submitting: false,
            typeDetails: data,
            success: true,
        },
    }),
    [types.SUBMIT_TYPE_FAILED]: (state, { errors }) => ({
        ...state,
        create: {
            ...state.create,
            submitting: false,
            success: false,
            errors,
        },
    }),

    // clear state
    [types.CLEAR_TYPE_CREATE_STATE]: (state) => ({
        ...state,
        create: {
            ...state.create,
            typeDetails: null,
            success: false,
            errors: null,
        },
    }),
};

export { types, actions };